import { THEME } from '@/config/theme';

export const LOCAL_SEAT_COLORS = [
  THEME.colors.magentaHex,
  THEME.colors.yellowHex,
  0xffa24a,
  THEME.colors.greenHex,
] as const;

export function getLocalSeatOrder(
  seatIndex: number,
  totalPlayers: number,
  localSeatIndices: number[],
): number | null {
  const localSet = new Set(localSeatIndices);
  if (!localSet.has(seatIndex)) return null;
  let order = 0;
  const total = Math.max(0, Math.min(totalPlayers, 4));
  for (let i = 0; i < total; i++) {
    if (!localSet.has(i)) continue;
    order += 1;
    if (i === seatIndex) return order;
  }
  return order || null;
}

export function getLocalSeatColor(
  seatIndex: number,
  totalPlayers: number,
  localSeatIndices: number[],
): number | null {
  const order = getLocalSeatOrder(seatIndex, totalPlayers, localSeatIndices);
  if (!order) return null;
  const paletteIndex = Math.min(Math.max(order - 1, 0), LOCAL_SEAT_COLORS.length - 1);
  return LOCAL_SEAT_COLORS[paletteIndex] ?? null;
}
